interface ProgressProps {
  value: number;          // 0..1, may exceed 1
  tone?: 'neutral' | 'positive' | 'warning' | 'danger';
  label?: string;
}

export function Progress({ value, tone = 'neutral', label }: ProgressProps) {
  const clamped = Math.max(0, Math.min(1, value));
  return (
    <div
      className="progress"
      role="progressbar"
      aria-valuenow={Math.round(clamped * 100)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
    >
      <div className="progress__fill" data-tone={tone} style={{ width: `${clamped * 100}%` }} />
    </div>
  );
}
